<section class="vc-admin-jobs-list">
  <app-admin-list-toolbar
    titleKey="ADMIN.JOBS.ALL"
    descriptionKey="ADMIN.IA.JOBS.DESCRIPTION"
    [showSearch]="true"
    searchPlaceholderKey="COMMON.SEARCH"
    [searchValue]="searchValue"
    (searchValueChange)="onSearch($event)"
  >
    <button
      toolbar-actions
      pButton
      type="button"
      icon="fas fa-plus"
      class="p-button-sm"
      [label]="'COMMON.ADD' | translate"
      (click)="router.navigate(['/administration', customer_route_param, 'jobs', 'new'])"
    ></button>
  </app-admin-list-toolbar>

  @if (filteredJobs.length === 0) {
    <app-admin-state-panel
      mode="empty"
      titleKey="ADMIN.JOBS.EMPTY.TITLE"
      descriptionKey="ADMIN.JOBS.EMPTY.DESCRIPTION"
    ></app-admin-state-panel>
  } @else {
    <p-table
      [value]="filteredJobs"
      responsiveLayout="scroll"
      [autoLayout]="true"
      styleClass="Table"
      [paginator]="true"
      [rows]="20"
      [rowsPerPageOptions]="[20, 40, 100]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>{{ "COMMON.NAME" | translate }}</th>
          <th>{{ "COMMON.ACTIONS" | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-job>
        <tr>
          <td>{{ job.name }}</td>
          <td>
            <app-admin-table-actions
              [manageRouterLink]="[
                '/administration',
                customer_route_param,
                'jobs',
                job.id
              ]"
              (delete)="confirm(job)"
            ></app-admin-table-actions>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</section>
